/**
 *
 * FormTab
 *
 */

import React from "react";
import { Li, Tab, TitleWrapper, TabTitle } from "./styledComponents";

const FormTab = ({
  disabled,
  onClick,
  title,
  isActive,
  disabledOthers,
  id,
  panelId,
  onKeyDown,
}) => {
  const isDisabled = Boolean(disabled || disabledOthers);
  return (
    <Li role="presentation">
      <Tab
        type="button"
        role="tab"
        id={id}
        aria-selected={isActive}
        aria-controls={isActive ? panelId : undefined}
        aria-disabled={isDisabled || undefined}
        tabIndex={isActive ? 0 : -1}
        onClick={() => {
          if (!isDisabled) {
            onClick();
          }
        }}
        onKeyDown={onKeyDown}
      >
        <TitleWrapper isActive={isActive}>
          <TabTitle isActive={isActive}>
            {title}
          </TabTitle>
        </TitleWrapper>
      </Tab>
    </Li>
  );
};

export default FormTab;
